<template>
  <div class="create_wrapper">
    <!-- Start Breadcrumb -->
    <Breadcrumb :items="items" />
    <!-- End Breadcrumb -->

    <div class="custom_card">
      <div class="card-header">
        <h4 class="card-title">{{ $t("addNew") }}</h4>
      </div>

      <!-- ==== Start Form ==== -->
      <form @submit.prevent="validateCreateForm">
        <div class="row justify-content-between">
          <!-- Partner -->
          <div class="repeater_wrapper mt-6">
            <h5>بيانات الشريك</h5>
            <div class="row justify-content-between">
              <!-- ********** Row Data ********** -->
              <div class="col-lg-8 mx-auto">
                <div class="upload_input_wrapper">
                  <uplode-image
                    @inputChanged="uplodeImg"
                    placeHolder="أرفق صورة  "
                  ></uplode-image>
                </div>
              </div>
              <div class="col-lg-6 py-0">
                <div class="input_wrapper top_label">
                  <input
                    type="text"
                    class="form-control"
                    @input="helper_checkIfInputIsEmpty"
                    @keypress="isArabic"
                    v-model.trim="data.alt_image_ar"
                  />
                  <label for="name_input" class="form-label"
                    >النص البديل للصورة (عربي)</label
                  >
                </div>
              </div>
              <div class="col-lg-6 py-0">
                <div class="input_wrapper top_label">
                  <input
                    type="text"
                    class="form-control"
                    @input="helper_checkIfInputIsEmpty"
                    @keypress="isEnglish"
                    v-model.trim="data.alt_image_en"
                  />
                  <label for="name_input" class="form-label"
                    >النص البديل للصورة (إنجليزي)</label
                  >
                </div>
              </div>
              <div class="col-lg-6">
                <div class="input_wrapper top_label col-lg-11">
                  <input
                    type="text"
                    class="form-control"
                    @input="helper_checkIfInputIsEmpty"
                    @keypress="isArabic"
                    v-model.trim="data.ar.name"
                  />
                  <label for="name_input" class="form-label">الاسم(عربي)</label>
                </div>
              </div>
              <div class="col-lg-6">
                <div class="input_wrapper top_label col-lg-11">
                  <input
                    type="text"
                    class="form-control"
                    @input="helper_checkIfInputIsEmpty"
                    @keypress="isEnglish"
                    v-model.trim="data.en.name"
                  />
                  <label for="name_input" class="form-label"
                    >الاسم(انجليزي)</label
                  >
                </div>
              </div>

              <div class="input_wrapper top_label col-lg-6 mx-auto">
                <input
                  type="url"
                  class="form-control"
                  @input="helper_checkIfInputIsEmpty"
                  v-model.trim="data.link"
                />
                <label for="name_input" class="form-label">الرابط</label>
              </div>
            </div>
          </div>
        </div>
        <div class="buttons_wrapper">
          <button class="base-btn">
            {{ $t("forms.submit") }}
            <span class="btn_loader" v-if="btnIsLoading"></span>
          </button>
        </div>
      </form>
      <!-- ==== End Form ==== -->
    </div>
  </div>
</template>

<script>
export default {
  name: "Create",

  data() {
    return {
      // ========== Breadcrumbs
      items: [
        {
          text: this.$t("breadcrumb.mainPage"),
          disabled: false,
          href: "/",
        },
        {
          text: this.$t("breadcrumb.partners.title"),
          disabled: false,
          href: "/partners",
        },
        {
          text: this.$t("breadcrumb.partners.add"),
          disabled: true,
          href: "",
        },
      ],

      // ========== Loading
      btnIsLoading: false,

      // ========== Data
      data: {
        image: null,
        link: null,
        alt_image_ar: null,
        alt_image_en: null,
        ar: {
          name: null,
        },
        en: {
          name: null,
        },
      },
    };
  },

  methods: {
    uplodeImg(obj) {
      this.data.image = obj;
    },
    // Validate Data
    validateCreateForm() {
      this.btnIsLoading = true;
      if (!this.data.image) {
        this.$iziToast.error({
          timeout: 2000,
          message: "أدخل الصورة",
          position: "bottomRight",
        });
        this.btnIsLoading = false;
        return;
      } else if (!this.data.ar.name) {
        this.$iziToast.error({
          timeout: 2000,
          message: "أدخل اسم الشريك بالعربي",
          position: "bottomRight",
        });
        this.btnIsLoading = false;
        return;
      } else if (!this.data.en.name) {
        this.$iziToast.error({
          timeout: 2000,
          message: "ادخل اسم الشريك بالانجليزي",
          position: "bottomRight",
        });
        this.btnIsLoading = false;
        return;
        //    } else if (!this.data.link) {
        //    this.$iziToast.error({
        //    timeout: 2000,
        //  message: "أدخل الرابط",
        //position: "bottomRight",
        //});
        // this.btnIsLoading = false;
        // return;
      } else {
        this.submitData();
        return;
      }
    },

    // Submit Data
    submitData() {
      const submit_data = new FormData();

      submit_data.append("ar[name]", this.data.ar.name);
      submit_data.append("en[name]", this.data.en.name);
      if (this.data.alt_image_ar) {
        submit_data.append(`ar[alt_image]`, this.data.alt_image_ar);
      }
      if (this.data.alt_image_en) {
        submit_data.append(`en[alt_image]`, this.data.alt_image_en);
      }
      submit_data.append("image", this.data.image.img_file);
      if (this.data.link) {
        submit_data.append("link", this.data.link ?? "");
      }

      this.axios({
        method: "POST",
        url: "partner",
        data: submit_data,
      })
        .then(() => {
          this.$iziToast.success({
            timeout: 2000,
            message: this.$t("addSuccess"),
            position: "bottomRight",
          });
          this.$router.push({ path: "/partners" });
          this.btnIsLoading = false;
        })
        .catch((err) => {
          this.$iziToast.error({
            timeout: 2000,
            message: err.response.data.message,
            position: "bottomRight",
          });
          this.btnIsLoading = false;
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.repeater_wrapper {
  // border: 1px solid #29398C;
  border-radius: 15px;
  padding-block: 20px;
  column-gap: 10px;

  h3,
  h5 {
    color: #29398c;
  }

  &.disabled {
    cursor: not-allowed;

    h3 {
      color: gray;
      font-size: 25px;
    }

    h4 {
      font-size: 21px;
      color: gray;
    }

    & > * {
      pointer-events: none;
    }
  }
}
</style>
